<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/JN2Zpl/tc-custom/9780226394312.jpg?1731213400860" alt="This image is the cover for the book Sophistry and Political Philosophy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sophistry and Political Philosophy
      </h1>
      <p class="bookDescription body article font2">
        <p>One of the central challenges to contemporary political philosophy is the apparent impossibility of arriving at any commonly agreed upon “truths.” As Nietzsche observed in his <i>Will to Power,</i> the currents of relativism that have come to characterize modern thought can be said to have been born with ancient sophistry. If we seek to understand the strengths and weaknesses of contemporary radical relativism, we must therefore look first to the sophists of antiquity—the most famous and challenging of whom is Protagoras.<br/><br/> With <i>Sophistry and Political Philosophy,</i> Robert C. Bartlett provides the first close reading of Plato’s two-part presentation of Protagoras. In the “Protagoras,” Plato sets out the sophist’s moral and political teachings, while the “Theaetetus,” offers a distillation of his theoretical and epistemological arguments. Taken together, the two dialogues demonstrate that Protagoras is attracted to one aspect of conventional morality—the nobility of courage, which in turn is connected to piety. This insight leads Bartlett to a consideration of the similarities and differences in the relationship of political philosophy and sophistry to pious faith. Bartlett’s superb exegesis offers a significant tool for understanding the history of philosophy, but, in tracing Socrates’s response to Protagoras’ teachings, Bartlett also builds toward a richer understanding of both ancient sophistry and what Socrates meant by “political philosophy.”<br/>  </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Robert C. Bartlett
      </h2>
      
      <p class="authorDescription body article"><B>Robert C. Bartlett</B> is the Behrakis Professor of Hellenic Political Studies at Boston College. He is the author or editor or seven books, including <I>The Idea of Enlightenment,</I> Plato’s <I>“Protagoras” and “Meno,”</I> and Xenophon’s <I>The Shorter Socratic Writings,</I> and cotranslator of <I>Aristotle’s Nicomachean Ethics,</I> also published by the University of Chicago Press.<br> &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0f9da642